import client from "shared/setupClient";
import { loader } from "graphql.macro";

const editChecklistItemMutation = loader("graphql/mutations/checklist/editChecklistItem.graphql");

export default function editChecklistItemAction(checklistId, item) {
    const { label, sequenceNumber, type } = item;
    const variables = { checklistId, label, type, itemSequenceNumber: sequenceNumber };
    return client.mutate({
        mutation: editChecklistItemMutation, variables
    });
}
